import { Container, Title, Text, Card, Group, Button, SimpleGrid, /*Image*/ } from '@mantine/core';
import { ShieldCheck, Users, Globe } from 'lucide-react';
import {useMediaQuery} from "@mantine/hooks";


const TrustSecuritySection = () => {
  return (
    <Container size="lg" py={50} px="sm">
    <Title order={2} align="center" mb={20}>
      🔒 Trust & Security Assurance
    </Title>

    <SimpleGrid
      cols={3}
      spacing="lg"
      breakpoints={[
        // tablets & smaller → 2 cols down from 3
        { maxWidth: 'md', cols: 2 },
        // phones → 1 col
        { maxWidth: 'sm', cols: 1 },
      ]}
    >
      <Card shadow="md" p="lg" radius="md">
        <ShieldCheck size={40} color="#4CAF50" />
        <Text weight={500} mt={10}>Secure Payment Processing</Text>
        <Text size="sm">
          We use industry-standard encryption to keep all transactions safe and secure.
        </Text>
      </Card>

      <Card shadow="md" p="lg" radius="md">
        <Users size={40} color="#4CAF50" />
        <Text weight={500} mt={10}>Verified Fundraisers</Text>
        <Text size="sm">
          Every campaign undergoes a vetting process to minimize fraud and ensure authenticity.
        </Text>
      </Card>

      <Card shadow="md" p="lg" radius="md">
        <Globe size={40} color="#4CAF50" />
        <Text weight={500} mt={10}>Transparent Fund Management</Text>
        <Text size="sm">
          Donations are tracked with clarity, ensuring funds reach the intended causes.
        </Text>
      </Card>
    </SimpleGrid>
  </Container>
);
  
};

/*const SocialProofSection = () => {
  return (
    <Container size="lg" py={50}>
      <Title order={2} align="center" mb={20}>🌟 As Featured In</Title>
      <Group position="center" spacing="xl">
        <Image src="/media1.png" alt="Media 1" height={50} />
        <Image src="/media2.png" alt="Media 2" height={50} />
        <Image src="/media3.png" alt="Media 3" height={50} />
      </Group>
    </Container>
  );
};*/

const CommunityEngagementSection = () => {
  const matchesMobile = useMediaQuery('(max-width: 600px)');


  return (
    <Container size="lg" py={50}>
      <Title order={2} mb={10} align={matchesMobile ? 'center' : 'start'}>🎉 Join  FundReach Community</Title>
      <Text size="sm" mb={20} align={matchesMobile ? 'center' : 'start'} style={{marginLeft:"10px"}}>Stay updated, connect with fellow fundraisers, and make a difference.</Text>
      <Group position="center" spacing="md">
        {/*<Button component="a" href="https://twitter.com/fundreach" target="_blank" color="blue">Twitter</Button>*/}
        <Button component="a" href="https://web.facebook.com/profile.php?id=61573755056980" target="_blank" color="blue">Facebook</Button>
        <Button component="a" href="https://www.linkedin.com/showcase/106484576/admin/dashboard/" target="_blank" color="blue">LinkedIn</Button>
      </Group>
    </Container>
  );
};

const FundReachExtraSections = () => {
  return (
    <>
      <TrustSecuritySection />
      {/*<SocialProofSection />*/}
      <CommunityEngagementSection />
    </>
  );
};

export default FundReachExtraSections;
